module.exports = __webpack_public_path__ + "img/2-right-grey.f347acc4.png";